import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../components/breadcrumb/Breadcrumb";
import useVisite from "../../../hooks/useVisite";
import "../../../assets/css/admin/gestionVisite/AdminVisitesPage.css";

export default function AdminVisitesPage({ setAlert }) {
    const { getAllVisites } = useVisite();

    const [visites, setVisites] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dateDebut, setDateDebut] = useState("");
    const [dateFin, setDateFin] = useState("");

    const [page, setPage] = useState(1);
    const itemsPerPage = 15;

    const breadcrumbItems = [
        { label: "Dashboard Admin", link: "/admin/dashboard" },
        { label: "Visites" },
    ];

    const formatDateTime = (d) => {
        if (!d) return "—";
        return new Date(d).toLocaleString("fr-FR");
    };

    const fetchVisites = async () => {
        setLoading(true);

        try {
            const response = await getAllVisites({ dateDebut, dateFin });
            const data = response?.data ?? [];
            setVisites(Array.isArray(data) ? data : []);
            setPage(1);
        } catch (error) {
            console.error(error);
            setAlert?.({
                type: "danger",
                message: "Impossible de charger les visites.",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVisites();
    }, []);

    const totalPages = Math.ceil(visites.length / itemsPerPage);

    const paginatedVisites = visites.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
    );

    return (
        <div className="adminDashboardPage">
            <div className="container">
                <Breadcrumb items={breadcrumbItems} />

                <div className="adminVisitesFilters">
                    <div className="adminVisitesDateField">
                        <label>Date début</label>
                        <div className="adminVisitesInputWrap">
                            <i className="bi bi-calendar3" />
                            <input
                                type="date"
                                value={dateDebut}
                                onChange={(e) => setDateDebut(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="adminVisitesDateField">
                        <label>Date fin</label>
                        <div className="adminVisitesInputWrap">
                            <i className="bi bi-calendar-check" />
                            <input
                                type="date"
                                value={dateFin}
                                onChange={(e) => setDateFin(e.target.value)}
                            />
                        </div>
                    </div>

                    <button
                        type="button"
                        className="adminVisitesBtn"
                        onClick={fetchVisites}
                    >
                        <i className="bi bi-funnel" />
                        <span>Filtrer</span>
                    </button>

                    <button
                        type="button"
                        className="adminVisitesBtn adminVisitesBtnSoft"
                        onClick={() => {
                            setDateDebut("");
                            setDateFin("");
                            setTimeout(fetchVisites, 0);
                        }}
                    >
                        <i className="bi bi-x-circle" />
                        <span>Réinitialiser</span>
                    </button>
                </div>

                <div className="adminDashboardPanel">
                    {loading ? (
                        <div className="panelEmpty">Chargement…</div>
                    ) : visites.length === 0 ? (
                        <div className="panelEmpty">Aucune visite.</div>
                    ) : (
                        <div style={{ overflowX: "auto" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: "left", padding: "12px" }}>Utilisateur</th>
                                        <th style={{ textAlign: "left", padding: "12px" }}>Email</th>
                                        <th style={{ textAlign: "left", padding: "12px" }}>Page visitée</th>
                                        <th style={{ textAlign: "left", padding: "12px" }}>IP</th>
                                        <th style={{ textAlign: "left", padding: "12px" }}>Date</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {paginatedVisites.map((v) => {
                                        const user = v?.utilisateur;
                                        const nom = user
                                            ? `${user?.nom ?? ""} ${user?.prenom ?? ""}`.trim()
                                            : "Visiteur non connecté";

                                        return (
                                            <tr key={v._id}>
                                                <td style={{ padding: "12px", borderTop: "1px solid #eee" }}>
                                                    {nom || "—"}
                                                </td>

                                                <td style={{ padding: "12px", borderTop: "1px solid #eee" }}>
                                                    {user?.email || "—"}
                                                </td>

                                                <td style={{ padding: "12px", borderTop: "1px solid #eee" }}>
                                                    {v?.path || "—"}
                                                </td>

                                                <td style={{ padding: "12px", borderTop: "1px solid #eee" }}>
                                                    {v?.ip || "—"}
                                                </td>

                                                <td style={{ padding: "12px", borderTop: "1px solid #eee" }}>
                                                    {formatDateTime(v?.createdAt)}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            <div className="adminVisitesPagination">
                                <button
                                    className="adminVisitesPageBtn"
                                    disabled={page === 1}
                                    onClick={() => setPage((p) => p - 1)}
                                >
                                    <i className="bi bi-chevron-left" />
                                </button>

                                <span className="adminVisitesPageInfo">
                                    Page {page} / {totalPages || 1}
                                </span>

                                <button
                                    className="adminVisitesPageBtn"
                                    disabled={page === totalPages || totalPages === 0}
                                    onClick={() => setPage((p) => p + 1)}
                                >
                                    <i className="bi bi-chevron-right" />
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}